import api from './api';

export default {
  update(data, route) {
    return api.execute('put', `api/${route}`, null, data);
  },
};
